import API from '../global/api';

export function utilitiesLoad (marina = null) {
    return async dispatch => {

        // Loading
        dispatch({
            type: 'UTILITIES_LOAD',
            status: 'LOADING',
            payload: null
        })


        if(marina !== null){

            try {
  
                const data = await API.req(`/utilities/${marina}`, 'GET');
                dispatch({
                    type: 'UTILITIES_LOAD',
                    status: 'OK',
                    payload: data.result
                })
                
            } catch (err) {

                dispatch({
                    type: 'UTILITIES_LOAD',
                    status: 'error',
                    payload: typeof err.msg === 'string' ? err.msg : 'Sorry we were unable to load your utilities'
                })

            }
  
        }

    }
}

export function utilityUpdate (payload) {
    return async dispatch => {

        // Loading
        dispatch({
            type: 'UTILITY_UPDATE',
            status: 'OK',
            payload: payload
        })
        
    }
}

export function utilitiesUpdate (payload) {
    return async dispatch => {

        dispatch({
            type: 'UTILITIES_LOAD',
            status: 'OK',
            payload: payload
        })

    }
}